
export default {
  layout: "i18n",
};
